import axios from 'axios';
import type { ApiResponse, CatalogData } from '../types/catalog';
import { attachAuthInterceptors } from '../../_shared/auth/authInterceptor';

const BASE_URL = import.meta.env.VITE_API_BASE ?? '/api/eraf';

export const catalogApiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachAuthInterceptors(catalogApiClient);

// Request interceptor — attach auth token (remember-me → localStorage, else → sessionStorage)
catalogApiClient.interceptors.request.use((config) => {
  const token =
    localStorage.getItem('access_token') ?? sessionStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor — unwrap ApiResponse<T>
catalogApiClient.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === 'object' && 'success' in response.data) {
      if (!response.data.success) {
        return Promise.reject({
          message: response.data.error?.message ?? 'Unknown error',
          code: response.data.error?.code,
          traceId: response.data.traceId,
        });
      }
      response.data = response.data.data;
    }
    return response;
  },
  (error) => {
    const traceId = error.response?.headers?.['x-trace-id'];
    const message =
      error.response?.data?.error?.message ??
      error.response?.data?.message ??
      error.message ??
      'Network error';
    return Promise.reject({ message, traceId, code: error.response?.data?.error?.code });
  }
);

export const catalogApi = {
  getCatalog: async (): Promise<CatalogData> => {
    const response = await catalogApiClient.get<ApiResponse<CatalogData>>('/biz/catalog');
    return response.data as unknown as CatalogData;
  },
};
